module.exports = __webpack_public_path__ + "static/media/052.3e805595.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/052.jpg
// module id = 347
// module chunks = 0